import React, {
  useEffect,
  useState,
  useRef,
  useMemo,
  useCallback,
} from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../store";
import {
  ClearSubmissionHistory,
  FetchSubmissionHistory,
  HideBidPanelAction,
  IApplicationState,
  SubmitBidAction,
} from "../../store";
import {
  BidButtonLabelEnum,
  BidIconTypeEnum,
  BidMessageEnum,
  BidMessageTypeEnum,
  BidProductTypeEnum,
  BidStatus,
  IBid,
  IBidCreation,
  IBidItem,
  IBidPanelRowDetails,
  IInterval,
  IAuction,
  IValidationResult,
  IBidResult,
  BookService,
  BidService,
  IDocumentBookCode,
} from "../../services";
// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-redeclare
import {Icons,Text,Alert,TextInput,Button, Sizes, Sentiments} from '@sede-enterprise/shell-ds-react-framework'
import { LoadingIndicator } from "../../components/LoadingIndicator/LoadingIndicator"; 
import Pagination from "rc-pagination";
import moment from "moment-timezone";
import 'ag-grid-community/styles/ag-theme-alpine.css';
import "rc-pagination/assets/index.css";
import {
  BidAreaStyle,
  BidBodyModal,
  BidFooterModal,
  BidGridStyle,
  BidHeaderModal,
  BidPanelStyle,
  BookContainer,
  PaginationPageStyle,
  PaginationStyle,
  QuantityAndPriceApplyEntryStyle,
  QuantityAndPriceApplyLabelStyle,
} from "./Bids.styled";

import {
  HideBidPanelActionWithNoChanges,
  ShowBidPanelAction,
} from "../../store/Bid/ActionCreator";
import {
  cloneObject,
  compareObjects,
  getAuctionTimezone,
  getMaxBids,
} from "../../core";
import {
  GridApi,
  ColDef,
  GridReadyEvent,
  GridOptions,
  CellValueChangedEvent,
  CellKeyDownEvent,
} from "ag-grid-community";
import "./Bids.css";
import styled, { useTheme } from "styled-components";
import BidHistory from "../BidHistory/BidHistory";
import DropDownList from "../../components/DropDownList/DropDownList";
import { AssociateBookWithDocIdAction } from "../../store/Book/ActionCreator";
import BidGrid from "../../components/Grid/BidGrid";
import { useDialog } from "../../components/react-async-dialog";
import uuid from "react-uuid";
import { ClearBookResult } from "../../store/Book/ActionCreator";
import { ExcelDropzone } from "../../components/ExcelDropzone";
import { toast } from "react-toastify";
import { CheckForBidPanelFunctionalities } from "../../helper/disabled-button";

const Bids: React.FC = () => {
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const dialog = useDialog();

  const bidPanel = useSelector((state: IApplicationState) => state.bidPanel);
  const newBlankBid = useSelector((state: IApplicationState) => state.bidPanel.newBlankBid);
  const bookSelector = useSelector((state: IApplicationState) => state.book);
  const [savedBids, setBids] = useState<IBid[]>(bidPanel.bids || ([cloneObject(newBlankBid!)] as IBid[]));
  const profilePage = useSelector((state : IApplicationState) => state.profile.profile);

  // messages and alerts
  const [showAlert, setShowAlert] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("Default");
  const [iconType, setIconType] = useState("");
  const [bookMessage, setBookMessage] = useState("");
  const [bookMessageType, setBookMessageType] = useState("Default");
  const [showBookMessage, setShowBookMessage] = useState(false);
  const [maintenanceMessage, setMaintenanceMessage] = useState("");
  const [showMaintenanceMessage, setShowMaintenanceMessage] = useState(false);
  const [bookIconType, setBookIconType] = useState("");
  const alertRef = useRef<HTMLDivElement>(null);
  const maxNoOfBidPagesAllowed = Number(getMaxBids());

  // button state
  const [submitBtnText, setSubmitBtnText] = useState(BidButtonLabelEnum.Submit);
  const [disableSubmitButton, setDisableSubmitButton] = useState(true);
  const [disableAddQtyAndPriceButton, setDisableAddQtyAndPriceButton] = useState(false);
  const [disableBookSubmission, setDisableBookSubmission] = useState(true);
  const [ghostSubmitButton, setGhostSubmitButton] = useState(true);
  const [ghostAddQtyAndPriceButton, setGhostAddQtyAndPriceButton] = useState(false);
  const [disableApplyBtn, setDisableApplyBtn] = useState(true);
  const [ghostApplyBtn, setGhostApplyBtn] = useState(true);

  const updateEnableSpreadsheetUpload = () => {
    const enable =
      bidPanel.auction?.bidStatus !== BidStatus.Closed &&
      !CheckForBidPanelFunctionalities(profilePage) && 
      (bidPanel.auction?.product === "Daily" ||
        bidPanel.auction?.product === "Intraday");
    return enable;
  };

  const [enableSpreadsheetUpload, setEnableSpreadsheetUpload] = useState(
    updateEnableSpreadsheetUpload()
  );
  
  //sync
  const auction = useSelector((state: IApplicationState) => state.bidPanel.auction);
  const [originalBidsResult, setOriginalBidsResult] = useState<IBid[]>(useSelector((state: IApplicationState) => state.bidPanel.originalBids || []));
  const [gridApi, setGridApi] = useState<GridApi | null>(null);
  

  // data editing
  const [currentPage, setCurrentPage] = useState(1);
  const [priceTextBoxVal, setPriceTextBoxVal] = useState("");
  const [bidQuantityTextBoxVal, setBidQuantityTextBoxVal] = useState("");
  //book state
  const [book, setBook] = useState("00000000-0000-0000-0000-000000000000");
  const [originalBook, setOriginalBook] = useState(
    "00000000-0000-0000-0000-000000000000"
  );
  //misc
  const bookService = new BookService();
  const bidService = useMemo(() => new BidService(), []);

  const totalPages = savedBids && savedBids.length > 0 ? savedBids.length : 0;

  //update from Redux when bids are updated from the server
  React.useEffect(() => {
    if (bidPanel?.bids) {
      setBids(bidPanel.bids);
    }
    setDisableAddQtyAndPriceButton(false);
    setGhostAddQtyAndPriceButton(false);
    if (totalPages >= maxNoOfBidPagesAllowed - 1) {
      setDisableAddQtyAndPriceButton(true);
      setGhostAddQtyAndPriceButton(true);
    }
  }, [bidPanel?.bids]);

  const buildBidPanelRowDetailsByIntervals = useCallback(
    (
      bidPeriod: any[],
      auctionTemplate?: IAuction,
      bidGuid?: string
    ): IBidPanelRowDetails[] => {
      const template = auctionTemplate?.productDetails
        ? auctionTemplate?.productDetails.map((x) => {
            return {
              corridorCode: x.corridorCode,
              offeredCapacity: x.offeredCapacity || 0,
              productHour:
                auctionTemplate.product === BidProductTypeEnum.Daily ||
                auctionTemplate.product === BidProductTypeEnum.Intraday
                  ? x.productHour.substring(0, 5)
                  : x.productHour,
              quantity: 0,
              price: 0,
              position: 0,
              bidGuid: bidGuid,
            } as IBidPanelRowDetails;
          })
        : [];
      let pos = 0;
      const sortedWithPosition = bidService
        .sortProductDetails(template)
        .map((x) => {
          pos++;
          x.position = pos;
          return x;
        });

      return sortedWithPosition.map((x) => {
        const foundInterval = bidPeriod.find(
          (y: any) => y.position === x.position
        );
        if (foundInterval) {
          x.price = foundInterval.priceAmount;
          x.quantity = foundInterval.quantity;
        }
        return x;
      });
    },
    [bidService]
  );

  const onGridReady = (params: GridReadyEvent) => {
    setGridApi(params.api);
  };
  
  const onCellKeyDown = ({ event }: CellKeyDownEvent) => {
    const keyboardEvent = event as KeyboardEvent;
    const isModifierKey = keyboardEvent.getModifierState('Shift') || 
                          keyboardEvent.getModifierState('Control') || 
                          keyboardEvent.getModifierState('Alt') || 
                          keyboardEvent.getModifierState('Meta');

    if (!isModifierKey && keyboardEvent?.key !== "Tab") {
      enableBidSubmission(true);
    }
  };
  

  const onCellValueChanged = (event: CellValueChangedEvent) => {
    updateBidRowQuantity(event.data)
  }

  const gridOptions: GridOptions = {
    rowHeight: 40,
    headerHeight: 36,
  };

  const updateBidRowQuantity = (bidPanelRowDetail: IBidPanelRowDetails) => {
    const updatedBid = savedBids[currentPage - 1] as IBid;
    if (updatedBid && updatedBid?.bidPanelRowDetails) {
      updatedBid.bidPanelRowDetails = updatedBid.bidPanelRowDetails.map((x) => {
        if (x.productHour === bidPanelRowDetail.productHour) {
          x.quantity = bidPanelRowDetail.quantity;
        }
        return x;
      });
      updatedBid.isDirty = true;
      updatedBid.status =
        updatedBid.status === BidStatus.Accepted ||
        updatedBid.status === BidStatus.Amended
          ? BidStatus.Amended
          : BidStatus.Draft;
      bidService.validateAllRows(
        updatedBid.bidPanelRowDetails,
        setAlertMessage,
        enableBidSubmission
      );
    }
  };

  const updateBidRowPrice = (bidPanelRowDetail: IBidPanelRowDetails) => {
    const updatedBid = savedBids[currentPage - 1] as IBid;
    if (updatedBid && updatedBid.bidPanelRowDetails) {
      updatedBid.bidPanelRowDetails = updatedBid.bidPanelRowDetails.map((x) => {
        if (x.productHour === bidPanelRowDetail.productHour) {
          x.price = bidPanelRowDetail.price;
        }
        return x;
      });
      updatedBid.isDirty = true;
      updatedBid.status =
        updatedBid.status === BidStatus.Accepted ||
        updatedBid.status === BidStatus.Amended
          ? BidStatus.Amended
          : BidStatus.Draft;
      bidService.validateAllRows(
        updatedBid.bidPanelRowDetails,
        setAlertMessage,
        enableBidSubmission
      );
      let updatedBids = savedBids.slice(0);
      var foundIndex = updatedBids.findIndex((x: IBid) => x.id === currentPage);
      updatedBids[foundIndex] = updatedBid;
      setBids([...updatedBids]);
    }
  };

  const disableApplyAll = (disable: boolean) => {
    setDisableApplyBtn(disable);
    setGhostApplyBtn(disable);
  };

  const validateEntryForApplyQuantityAndPriceToAll = (
    bidQuantityAsString: string,
    priceQuantityAsString: string
  ) => {
    const quantity = Number(bidQuantityAsString);
    const price = Number(priceQuantityAsString);
    if (!isNaN(quantity) && !isNaN(price) && quantity > 0 && price > 0) {
      setBidQuantityTextBoxVal(bidQuantityAsString);
      setPriceTextBoxVal(priceQuantityAsString);
      disableApplyAll(false);
    } else {
      setBidQuantityTextBoxVal(bidQuantityAsString);
      setPriceTextBoxVal(priceQuantityAsString);
      disableApplyAll(true);
    }
  };

  const areBidsJustOneBlankBid = (changedBids: IBid[]) => {
    if (changedBids.length !== 1) {
      return false;
    }
    return !changedBids[0].bidPanelRowDetails?.some(
      (x) => x.quantity !== 0 || x.price !== 0
    );
  };

  const hasBidsChanged = (changedBids: IBid[], orginalBids: IBid[]) => {
    if (changedBids.length !== orginalBids.length) {
      return true;
    }

    let hasBidValuesChanged = false;
    for (const changedBid of changedBids) {
      const foundBid = orginalBids.find((x) => x.id === changedBid.id);
      if (!foundBid) {
        hasBidValuesChanged = true;
        break;
      }

      if (changedBid?.bidPanelRowDetails) {
        for (const details of changedBid.bidPanelRowDetails) {
          const foundDetails = foundBid.bidPanelRowDetails?.find(
            (x) => x.position === details.position
          );

          details.price = Number(details.price);
          details.quantity = Number(details.quantity);

          hasBidValuesChanged = !compareObjects(details, foundDetails);
          if (hasBidValuesChanged) return hasBidValuesChanged;
        }
      }
    }

    return hasBidValuesChanged;
  };

  const hasBidsGotQuantityGreaterThanCapacity = () => {
    let valid = true;
    const currentBids = savedBids;

    for (const currentBid of currentBids) {
      if (currentBid.bidPanelRowDetails) {
        for (const detail of currentBid.bidPanelRowDetails) {
          if (detail.offeredCapacity < detail.quantity) {
            valid = false;
            break;
          }
        }
      }
    }
    return valid;
  };

  const enableBidSubmission = useCallback(
    (enable: boolean) => {
      const disable = !enable
        || auction?.bidStatus === BidStatus.Closed
        || CheckForBidPanelFunctionalities(profilePage);

      setGhostSubmitButton(disable);
      setDisableSubmitButton(disable);
      setEnableSpreadsheetUpload(updateEnableSpreadsheetUpload());
    },
    [auction?.bidStatus]
  );

  const CheckBidsCumulativeQtyGreaterThanCapacity = () => {
    let valid = true;
    const currentBids = savedBids;

    // Start -- Loop Through All BidPositions -  To Get NoofBids
    for (const currentBid of currentBids) {
      if (currentBid.bidPanelRowDetails) {
        // Start -- Loop Through All Intervals - To Get NoOfIntervals
        for (const intervals of currentBid.bidPanelRowDetails) {
          var capacityQty: number = 0;
          var sumofBidsQty: number = 0;

          // Start - Loop Through everyBids for given Interval
          for (const everybid of currentBids) {
            if (everybid.bidPanelRowDetails) {
              // Loop through interval
              for (const pos of everybid.bidPanelRowDetails) {
                if (pos.position === intervals.position) {
                  capacityQty = Number(pos.offeredCapacity);
                  sumofBidsQty += Number(pos.quantity);
                  break;
                }
              }
            }
          } // End - Loop Through everyBids for given Interval

          // Check Cumuliative Bid Qty is Less Than OfferedQty
          if (sumofBidsQty > capacityQty) {
            valid = false;
            return valid;
          }
        } // End -- Loop Through All Intervals - To Get NoOfIntervals
      }
      break; // Do Not Remove - We Just Want Validation to be done Once
    } // End -- Loop Through All BidPositions To GetNo of Bids
    return valid;
  };

  const getBidsFromBidResult = useCallback(
    (bidResult: IBidResult, auction: IAuction) => {
      const bids = bidResult.bids.map((x) => {
        return {
          id: x.bidId,
          bidGuid: x.bidGuid,
          status: bidResult.status,
          auctionIdentification: bidResult.documentId,
          corridorCode: auction?.corridor,
          bidPanelRowDetails: buildBidPanelRowDetailsByIntervals(
            x.period,
            auction,
            x.bidGuid
          ),
          isDirty: false,
        } as IBid;
      });
      return bids;
    },
    [buildBidPanelRowDetailsByIntervals]
  );

  const buildErrorMessageForRejectedBids = (errors: string[]) => {
    const auctionDetails = `${auction?.interconnector} ${auction?.corridor} ${auction?.product}`;

    if (errors === null || typeof errors === "undefined") {
      return `${auctionDetails}: ${BidMessageEnum.CannotSubmitBidPlaceOrderDirectly}`;
    }

    switch (errors.length) {
      case 0:
        return `${auctionDetails}: ${BidMessageEnum.CannotSubmitBidPlaceOrderDirectly}`;

      case 1:
        return `${auctionDetails}: ${BidMessageEnum.CannotSubmitBid} ${BidMessageEnum.ErrorMessageFromTheExchange}: ${errors[0]}`;

      default:
        return `${auctionDetails}: ${BidMessageEnum.CannotSubmitBid} ${
          BidMessageEnum.ErrorMessageFromTheExchange
        }: ${errors
          .slice(0, 3)
          .map((x, i) => `${i + 1}. ${x}`)
          .join(" ")}`;
    }
  };

  useEffect(() => {
    setEnableSpreadsheetUpload(updateEnableSpreadsheetUpload());
    if (bidPanel.bidSubmissionResponse?.status === BidStatus.Rejected) {
      const errorMessage = buildErrorMessageForRejectedBids(
        bidPanel.bidSubmissionResponse?.errors
      );

      setAlertMessage(
        true,
        BidMessageTypeEnum.error,
        BidIconTypeEnum.error,
        errorMessage
      );

      const bidResult = bidPanel?.auction?.bidResult;
      if (bidResult && auction) {
        const currentBids = getBidsFromBidResult(bidResult, auction);
        setOriginalBidsResult(cloneObject(currentBids));
      }
    }
    if (bidPanel.bidSubmissionResponse?.status === BidStatus.Accepted) {
      enableBidSubmission(false);
      setSubmitBtnText(BidButtonLabelEnum.Resubmit);
      setAlertMessage(
        true,
        BidMessageTypeEnum.success,
        BidIconTypeEnum.success,
        BidMessageEnum.success
      );

      const bidResult = bidPanel?.auction?.bidResult;
      if (bidResult && auction) {
        const currentBids = getBidsFromBidResult(bidResult, auction);
        setOriginalBidsResult(cloneObject(currentBids));
      }
      // refresh Redux state with results from the server
      if (auction) {
        dispatch(ShowBidPanelAction(auction));
      }
    }
    if (
      bidPanel.auction?.bidStatus === BidStatus.Draft ||
      bidPanel.auction?.bidStatus === BidStatus.Amended
    ) {
      enableBidSubmission(true);
    }
    if (bidPanel.status === BidStatus.ServerError) {
      setAlertMessage(
        true,
        BidMessageTypeEnum.error,
        BidIconTypeEnum.error,
        BidMessageEnum.CannotSubmitBidPlaceOrderDirectly
      );
    }
    if (
      bidPanel.auction?.maintenances &&
      bidPanel.auction?.maintenances.length > 0
    ) {
      let maintenanceMessage = "Capacity reduced to 0, Maintenance Scheduled from ";
      const maintenances = bidPanel.auction.maintenances;
      let maintenanceCount = 1;
      for (let maintenance of maintenances) {
        maintenanceMessage +=
          (maintenances.length > 1 ? maintenanceCount.toString() + ") " : "") +
          moment(maintenance.periodStart).tz(getAuctionTimezone()).format("DD/MM/yyyy (HH:mm)") + " to " +
          moment(maintenance.periodStop).tz(getAuctionTimezone()).format("DD/MM/yyyy (HH:mm)") + ". ";
        maintenanceCount++;
      }
      setMaintenanceMessage(maintenanceMessage);
      setShowMaintenanceMessage(true);
    } else {
      setShowMaintenanceMessage(false);
    }
    const hasSuccessfullyBid = bidPanel?.auction?.hasSuccessfullyBid;
    if (hasSuccessfullyBid) {
      setSubmitBtnText(BidButtonLabelEnum.Resubmit);
    } else {
      setSubmitBtnText(BidButtonLabelEnum.Submit);
    }
    return () => {
      if (bidPanel && bidPanel.bids && bidPanel.bids.length < 1) {
        // if no bids then set an initial bid
        setCurrentPage(1);
        setBids([]);
        setMessage("");
        setSubmitBtnText(BidButtonLabelEnum.Submit);
        setAlertMessage(
          false,
          BidMessageTypeEnum.default,
          BidIconTypeEnum.success,
          BidMessageEnum.success
        );
        setAlertForBookMessage(
          false,
          BidMessageTypeEnum.default,
          BidIconTypeEnum.info,
          BidMessageEnum.default
        );
        enableBidSubmission(false);
        setDisableApplyBtn(true);
        setGhostApplyBtn(true);
        setPriceTextBoxVal("");
        setBidQuantityTextBoxVal("");
        setDisableAddQtyAndPriceButton(false);
        setGhostAddQtyAndPriceButton(false);
        setBook("00000000-0000-0000-0000-000000000000");
        setOriginalBook("00000000-0000-0000-0000-000000000000");
        setDisableBookSubmission(true);
      }
    };
  }, [bidPanel, auction, getBidsFromBidResult, enableBidSubmission, dispatch]);

  const updatePage = (current: number) => {
    setCurrentPage(current);

    let valid = true;
    for (const bid of savedBids) {
      if (bid.bidPanelRowDetails) {
        valid =
          bidService.validateAllRows(bid.bidPanelRowDetails) ||
          bid.status === BidStatus.Amended;
        if (!valid) break;
      }
    }

    setDisableApplyBtn(true);
    setGhostApplyBtn(true);
    setPriceTextBoxVal("");
    setBidQuantityTextBoxVal("");

    if (!valid) {
      setAlertMessage(
        true,
        BidMessageTypeEnum.error,
        BidIconTypeEnum.error,
        BidMessageEnum.OnlyPositiveNumericsAllowed
      );
      enableBidSubmission(false);
    } else {
      setAlertMessage(
        false,
        BidMessageTypeEnum.default,
        BidIconTypeEnum.info,
        BidMessageEnum.success
      );
      enableBidSubmission(true);
    }
  };

  const setAlertMessage = (
    show: boolean,
    messageType: BidMessageTypeEnum,
    iconType: BidIconTypeEnum,
    message: string
  ) => {
    setMessage(message);
    setIconType(iconType.toString());
    setMessageType(messageType);
    setShowAlert(show);
    if (show && alertRef.current) {
      alertRef.current.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  };

  const setAlertForBookMessage = (
    show: boolean,
    messageType: BidMessageTypeEnum,
    iconType: BidIconTypeEnum,
    message: string
  ) => {
    setBookIconType(iconType);
    setBookMessageType(messageType);
    setShowBookMessage(show);
    setBookMessage(message);
  };

  //submission and validation
  const submitBid = async () => {
    if (book === "00000000-0000-0000-0000-000000000000") {
      dispatch(
        AssociateBookWithDocIdAction({
          bookCode: book,
          docId: auction?.identification,
          corridorCode:
            auction?.interconnector?.toLowerCase() === "N/A".toLowerCase()
              ? auction?.corridor
              : `${auction?.interconnector}-${auction?.corridor}`,
        } as IDocumentBookCode)
      );
    }
    const validUptoTwoDecimalPlaces = bidService.validateDecimalPlaces(
      savedBids,
      2
    );
    if (!validUptoTwoDecimalPlaces) {
      return setAlertMessage(
        true,
        BidMessageTypeEnum.error,
        BidIconTypeEnum.error,
        BidMessageEnum.PricesCannotBeInThreeDecimalPlaces
      );
    }
    const bidCreated = buildBidsCreationObject(BidStatus.Submit, savedBids);
    const validationResult = validateAnyBidNotAllZero(
      bidCreated.bids.filter((x) => x.bidStatus === BidStatus.Draft)
    );
    if (!validationResult.valid) {
      setAlertMessage(
        true,
        BidMessageTypeEnum.error,
        BidIconTypeEnum.error,
        validationResult.bidErrorMessage
      );
    } else if (validationResult.allQuantitiesZero) {
      setAlertMessage(
        true,
        BidMessageTypeEnum.error,
        BidIconTypeEnum.error,
        validationResult.bidErrorMessage
      );
    } else {
      const validationResultForAmendments = validateAnyBidNotAllZero(
        bidCreated.bids.filter((x) => x.bidStatus !== BidStatus.Draft)
      );
      if (!validationResultForAmendments.valid) {
        const ok = await dialog.confirm(
          <strong>
            One or more bids have all zero values so have been voided. Are you
            sure you want to submit all these bids?
          </strong>,
          {
            ok: "Ok",
          }
        );
        if (!ok) {
          return;
        }
      }
      bidCreated.maintenance = auction?.maintenances;
      dispatch(SubmitBidAction(bidCreated));
    }
  };

  const buildBidsCreationObject = (
    bidStatus: BidStatus,
    currentBids: IBid[]
  ) => {
    let intervals: IInterval[] = [];
    let bidItems: IBidItem[] = [];

    currentBids.forEach((bid) => {
      // assemble all the interval rows for a bid
      intervals = [];
      bid.bidPanelRowDetails?.forEach((bidPanelRowDetail) => {
        intervals.push({
          position: bidPanelRowDetail.position,
          priceAmount: Number(bidPanelRowDetail.price),
          quantity: Number(bidPanelRowDetail.quantity),
          offeredCapacity: Number(bidPanelRowDetail.offeredCapacity),
        } as IInterval);
      });
      // then add the new bid with all those intervals
      bidItems.push({
        bidId: bid.id,
        bidStatus: bid.status,
        startDateTimeUtc: auction?.periodStart,
        endDateTimeUtc: auction?.periodStop,
        period: intervals,
        bidGuid: bid.bidGuid,
      } as IBidItem);
    });

    const bidCreation = {
      auctionIdentification: auction?.identification,
      corridorCode:
        auction?.interconnector?.toLowerCase() === "N/A".toLowerCase()
          ? auction?.corridor
          : `${auction?.interconnector}-${auction?.corridor}`,
      product: auction?.product,
      endDateTimeUtc: auction?.periodStop,
      startDateTimeUtc: auction?.periodStart,
      bids: bidItems,
      status: bidStatus,
      exchangeCode: auction?.exchangeCode,
      exchangeId: auction?.exchangeId,
    } as IBidCreation;
    return bidCreation;
  };

  const validateAnyBidNotAllZero = (bids: IBidItem[]) => {
    let valid = true;
    let bidErrorMessage = BidMessageEnum.success;
    let allQuantitiesZeroForDrafts = false;

    for (let bid of bids) {
      allQuantitiesZeroForDrafts = true;
      for (let interval of bid.period) {
        const quantity = Number(interval.quantity);
        const price = Number(interval.priceAmount);

        if (isNaN(price) || isNaN(quantity) || price < 0 || quantity < 0) {
          valid = false;
          allQuantitiesZeroForDrafts = false;
          bidErrorMessage = BidMessageEnum.OnlyPositiveNumericsAllowed;
          break;
        } else if (interval.quantity > 0) {
          allQuantitiesZeroForDrafts = false;
        }
      }
      if (allQuantitiesZeroForDrafts === true) break;
    }

    var isBidsQuantityLessOrEqualThanOfferedCapacity =
      hasBidsGotQuantityGreaterThanCapacity();
    if (!isBidsQuantityLessOrEqualThanOfferedCapacity) {
      return {
        valid: false,
        bidErrorMessage: BidMessageEnum.QuantityHigherThanCapacity,
        allQuantitiesZero: allQuantitiesZeroForDrafts,
      };
    }

    var isCumulativeValueLessOrEqualThanOfferedCapacity =
      CheckBidsCumulativeQtyGreaterThanCapacity();
    if (!isCumulativeValueLessOrEqualThanOfferedCapacity) {
      return {
        valid: false,
        bidErrorMessage: BidMessageEnum.SumOfBidQtyGTCapacity,
        allQuantitiesZero: allQuantitiesZeroForDrafts,
      };
    }
    if (allQuantitiesZeroForDrafts) {
      const validationResult = {
        valid: false,
        bidErrorMessage: BidMessageEnum.AllQuantityValuesAreaZero,
        allQuantitiesZero: allQuantitiesZeroForDrafts,
      };
      return validationResult;
    } else {
      const validationResult = {
        valid: valid,
        bidErrorMessage: bidErrorMessage,
        allQuantitiesZero: allQuantitiesZeroForDrafts,
      } as IValidationResult;
      return validationResult;
    }
  };

  // cancellations
  const voidBid = async () => {
    const ok = await dialog.confirm(
      <strong>
        This will wipe the data for this bid. Are you really sure?
      </strong>,
      {
        ok: "Ok",
      }
    );
    if (ok) {
      let updatedBid: IBid = savedBids[currentPage - 1];
      updatedBid.bidPanelRowDetails = updatedBid.bidPanelRowDetails?.map(
        (x) => {
          x.price = 0;
          x.quantity = 0;
          return x;
        }
      );
      updatedBid.status = BidStatus.Amended;
      updatedBid.isDirty = true;
      let updatedBids = savedBids.slice(0);
      var foundIndex = updatedBids.findIndex((x: IBid) => x.id === currentPage);
      updatedBids[foundIndex] = updatedBid;
      setBids([...updatedBids]);
      enableBidSubmission(true);
    }
  };

  const deleteBid = async () => {
    if (totalPages <= 1) return;
    else {
      const ok = await dialog.confirm(
        <strong>
          This will wipe the data for this bid. Are you really sure?
        </strong>,
        {
          ok: "Ok",
        }
      );
      if (ok) {
        if (totalPages <= maxNoOfBidPagesAllowed) {
          setDisableAddQtyAndPriceButton(false);
          setGhostAddQtyAndPriceButton(false);
        }
        const filteredBids = savedBids.filter(
          (x) => x.id !== savedBids[currentPage - 1]?.id
        );

        const shuffledBids = filteredBids.map((x) => {
          if (x.id > savedBids[currentPage - 1]?.id!) {
            x.id = x.id - 1;
          }
          return x;
        });
        setCurrentPage(currentPage - 1);
        setBids(shuffledBids);
        updatePage(currentPage - 1);
      }
    }
  };

  const voidorDeleteAllBids = async () => {
    const ok = await dialog.confirm(
      <strong>This will wipe all the bid data. Are you really sure?</strong>,
      {
        ok: "Ok",
      }
    );
    if (ok) {
      let updatedBids = cloneObject(savedBids);
      updatedBids = updatedBids.map((bid: IBid) => {
        if (bid.status === BidStatus.Draft) {
          if (bid.id === 1) {
            bid.bidPanelRowDetails?.map((x) => {
              x.price = 0;
              x.quantity = 0;
              return x;
            });
            return bid;
          }
        }
        if (bid.status !== BidStatus.Draft) {
          bid.bidPanelRowDetails = bid.bidPanelRowDetails?.map((x) => {
            x.price = 0;
            x.quantity = 0;
            return x;
          });
          bid.status = BidStatus.Amended;
          bid.isDirty = true;
          return bid;
        }
      });

      //filter out the undefined entries, which are where the above function didn't return a value for the drafts
      updatedBids = updatedBids
        .filter((y: any) => y)
        .filter((x: IBid) => x.status !== BidStatus.Draft || x.id === 1);
      let count = 1;
      updatedBids = updatedBids.map((x: IBid) => {
        x.id = count;
        count = count + 1;
        return x;
      });

      if (updatedBids.length < maxNoOfBidPagesAllowed) {
        setDisableAddQtyAndPriceButton(false);
        setGhostAddQtyAndPriceButton(false);
      }

      setBids(updatedBids);
      setCurrentPage(1);
      enableBidSubmission(true);
    }
  };

  const onWheelHandle = useCallback((e: React.WheelEvent<HTMLInputElement>) => {
    e.currentTarget.blur();
  }, []);

  const re = /^(?!0\d)(\d+(\.\d{0,2})?)$/;

  //grid
  const dailyBidProductColumns = useCallback(() => {
    return [
      {
        field: 'productHour',
        headerName: 'Time',
        focused: false,
        editable: false,
        resizable: true,
        disabled: true,
        tabIndex: -1
      },
      {
        field: 'offeredCapacity',
        headerName: 'Capacity(MW)',
        focused: false,
        editable: false,
        resizable: true,
        disabled: true,
        tabIndex: -1
      },
      {
        field: 'quantity',
        editable: true,
        cellEditor: 'agNumberCellEditor',
        valueSetter: (params) => {
          const validNumber = re.test(params.newValue);
          
          params.data.quantity = !validNumber
              ? params.data.quantity
              : params.newValue;

          return validNumber;
        },
        resizable: true
      },
      {
        field: 'price',
        editable: true,
        cellEditor: 'agNumberCellEditor',
        valueSetter: (params) => {
          const validNumber = re.test(params.newValue);
          
          params.data.price = !validNumber
              ? params.data.price
              : params.newValue;

          return validNumber;
        },
        resizable: true
      },
    ] as ColDef[];
  }, [
    bidPanel,
    updateBidRowQuantity,
    enableBidSubmission,
    setAlertMessage,
    onWheelHandle,
    profilePage,
    updateBidRowPrice,
  ]);
  const applyPriceAndQuantityAcrossAllFields = () => {
    const model = gridApi?.getModel();
    const bidPanelRowDetails: IBidPanelRowDetails[] = [];

    model?.forEachNode((x) => {
      bidPanelRowDetails.push({
        ...x.data,
        price: priceTextBoxVal,
        quantity: bidQuantityTextBoxVal,
      } as IBidPanelRowDetails);
    });

    if (savedBids[currentPage - 1]?.bidPanelRowDetails) {
        const updatedBid = savedBids[currentPage - 1];
        updatedBid.bidPanelRowDetails = bidPanelRowDetails;
        let updatedBids = savedBids.slice(0);
        var foundIndex = updatedBids.findIndex((x: IBid) => x.id === currentPage);
        updatedBids[foundIndex] = updatedBid;
        updatedBid.isDirty = true;
        updatedBid.status =
            updatedBid.status === BidStatus.Accepted ||
                updatedBid.status === BidStatus.Amended
                ? BidStatus.Amended
                : BidStatus.Draft;
        setBids([...updatedBids]);
    }

    enableBidSubmission(true);
  };

  // book
  const onBookSelectionChanged = (book: string) => {
    setBook(book);
    setDisableBookSubmission(originalBook === book);
  };

  const updateBookSelection = () => {
    dispatch(
      AssociateBookWithDocIdAction({
        bookCode: book,
        docId: auction?.identification,
        corridorCode:
          auction?.interconnector?.toLowerCase() === "N/A".toLowerCase()
            ? auction?.corridor
            : `${auction?.interconnector}-${auction?.corridor}`,
      } as IDocumentBookCode)
    );
  };

  useEffect(() => {
    if (bookSelector.bookAndDocId?.bookCode) {
      setBook(bookSelector.bookAndDocId?.bookCode);
      setOriginalBook(bookSelector.bookAndDocId.bookCode);
    }
  }, [bookSelector.bookAndDocId]);

  useEffect(() => {
    if (bookSelector.exceptionMessage) {
      setAlertForBookMessage(
        true,
        BidMessageTypeEnum.error,
        BidIconTypeEnum.error,
        bookSelector.exceptionMessage
      );
    }
  }, [bookSelector.exceptionMessage]);

  useEffect(() => {
    if (bookSelector.updateDocumentBookCodeResult?.updateSuccessful) {
      setAlertForBookMessage(
        true,
        BidMessageTypeEnum.success,
        BidIconTypeEnum.success,
        "Successfully Updated Book."
      );
      setOriginalBook(
        bookSelector.updateDocumentBookCodeResult.documentBookCode.bookCode
      );
      setDisableBookSubmission(true);
      dispatch(ClearBookResult());
    } else if (
      bookSelector.updateDocumentBookCodeResult?.updateSuccessful === false
    ) {
      setAlertForBookMessage(
        true,
        BidMessageTypeEnum.error,
        BidIconTypeEnum.error,
        "Error in Updating Book. Please contact IT Staff"
      );
      dispatch(ClearBookResult());
    }
  }, [bookSelector.updateDocumentBookCodeResult, dispatch]);

  //misc
  const renderPaginationItem = (
    page: number,
    type: string,
    element: React.ReactNode,
    status: string
  ) => {
    if (type === "page") {
      return (
        <PaginationPageStyle status={status}>{element}</PaginationPageStyle>
      );
    }
    return element;
  };

  const onClose = () => {
    setBook("00000000-0000-0000-0000-000000000000");
    setOriginalBook("00000000-0000-0000-0000-000000000000");
    dispatch(ClearBookResult());
    if (
      bidPanel.auction?.bidStatus === BidStatus.Closed ||
      CheckForBidPanelFunctionalities(profilePage) ||
      bidPanel.status === BidStatus.ServerError
    ) {
      return dispatch(HideBidPanelActionWithNoChanges());
    }
    const currentBids = savedBids;
    const overallStatus =
      //check if drafts have been deleted and needs to revert to just accepted
      currentBids.some((x) => x.status === BidStatus.Accepted) &&
      !currentBids.some(
        (x) => x.status === BidStatus.Draft || x.status === BidStatus.Amended
      )
        ? BidStatus.Revert
        : //check if it's an amendment after a previous submit
        currentBids.some(
            (x) =>
              x.status === BidStatus.Accepted || x.status === BidStatus.Amended
          )
        ? BidStatus.Amend
        : //else make it a draft
          BidStatus.Draft;

    const bidCreated = buildBidsCreationObject(overallStatus, currentBids);
    const validationResult = validateAnyBidNotAllZero(bidCreated.bids);

    if (
      !validationResult.valid &&
      !validationResult.allQuantitiesZero &&
      validationResult.bidErrorMessage !==
        BidMessageEnum.QuantityHigherThanCapacity
    ) {
      dispatch(ClearSubmissionHistory());
      return dispatch(HideBidPanelActionWithNoChanges());
    } else {
      const bidsChanged = hasBidsChanged(currentBids, originalBidsResult);
      const noRealBids = areBidsJustOneBlankBid(currentBids);
      if (
        !bidsChanged ||
        (noRealBids && !(originalBidsResult && originalBidsResult.length > 0))
      ) {
        dispatch(ClearSubmissionHistory());
        return dispatch(HideBidPanelActionWithNoChanges());
      }

      dispatch(HideBidPanelAction(bidCreated));
      dispatch(ClearSubmissionHistory());
    }
  };

  const addBid = () => {
    const currentBids = savedBids;
    if (bidService.allQuantityZeroForAPageInGivenBids(currentBids) === true) {
      setAlertMessage(
        true,
        BidMessageTypeEnum.error,
        BidIconTypeEnum.error,
        BidMessageEnum.AllQuantityValuesAreaZero
      );
    } else {
      setDisableAddQtyAndPriceButton(false);
      setGhostAddQtyAndPriceButton(false);
      if (totalPages >= maxNoOfBidPagesAllowed - 1) {
        setDisableAddQtyAndPriceButton(true);
        setGhostAddQtyAndPriceButton(true);
      }
      const newBidPageNumber: number = totalPages + 1;
      const newBid: IBid = cloneObject(newBlankBid);
      newBid.id = newBidPageNumber;
      newBid.bidGuid = uuid();
      newBid.bidPanelRowDetails = newBid.bidPanelRowDetails?.map((x) => {
        x.bidGuid = newBid.bidGuid;
        return x;
      });
      const updatedBids = cloneObject(savedBids);
      updatedBids.push(newBid);
      setBids([...updatedBids]);
      setCurrentPage(newBidPageNumber);
    }
  };

  const onSuccessfulValidation = (newBids: IBid[]) => {
    //check if there are less bids now than before.  If so we need to wipe out any old bids by using all zero values
    const numberOfOldBids = savedBids.length;
    const numberOfNewBids = newBids.length;
    const numberBidsLessThanBefore = numberOfOldBids - numberOfNewBids;
    if (numberBidsLessThanBefore > 0) {
      var pageNumber: number = numberOfNewBids;
      [...Array(numberBidsLessThanBefore)].forEach((x) => {
        pageNumber++;
        const newBid: IBid = cloneObject(newBlankBid);
        newBid.id = pageNumber;
        newBid.status = BidStatus.Amended;
        newBid.bidGuid = uuid();
        newBid.bidPanelRowDetails = newBid.bidPanelRowDetails?.map((x) => {
          x.bidGuid = newBid.bidGuid;
          return x;
        });
        newBids.push(newBid);
      });
    }

    //disable buttons if 20 bids
    const numberOfPages = newBids.length;
    if (numberOfPages >= maxNoOfBidPagesAllowed) {
      setDisableAddQtyAndPriceButton(true);
      setGhostAddQtyAndPriceButton(true);
    }

    // bid submission button needs to be enabled
    // following successful spreadsheet import
    enableBidSubmission(true);

    //actually apply the bids
    setBids([...newBids]);
    toast.success("Successful upload", { autoClose: 1000, draggable: true });
  };

  const activeAlertCount = [showAlert, showBookMessage].filter(Boolean).length;
  const hasAlerts = activeAlertCount > 0;
  const maintenanceMessagesCount = showMaintenanceMessage
    ? bidPanel.auction?.maintenances?.length || 0
    : 0;
 
  return (
    <BidPanelStyle data-testid="Bids">
      <BidHeaderModal>
        <Text size="small" >{bidPanel?.auction?.interconnector}</Text>
        <Text size="small" >{bidPanel?.auction?.product}</Text>
        <Text size="small" >
          Bidding close :{" "}
          {bidPanel?.auction?.biddingClose
            ? moment(bidPanel?.auction?.biddingClose)
                .tz(getAuctionTimezone())
                .format("DD-MMM-yyyy HH:mm:ss")
            : ""}
        </Text>
        <Icons.Cross className="crossIcon" onClick={onClose} />
        <h4 id="corridorHeader">{bidPanel?.auction?.corridor}</h4>
      </BidHeaderModal>
      <br />

      <BidBodyModal ref={alertRef}>
        <div className="alert-container">
          {showMaintenanceMessage && (
            <Alert 
              dismissible={true}
              id="maintenanceMessage" 
              size={Sizes.Large} 
              icon={<Icons.InfoCircle/>}
              sentiment={Sentiments.Information} 
              onDismissClick={()=> setShowMaintenanceMessage(false)} 
            >
              {maintenanceMessage}
            </Alert>
          )}
          
          {showAlert && <Alert id="alertMessage" 
          dismissible={true}
          onDismissClick={()=>{
            setShowAlert(false);
          }} 
          sentiment={iconType === "error" ? Sentiments.Negative : (
            iconType === "success" ? Sentiments.Positive : Sentiments.Information
          )}
          icon={iconType === "error" ? <Icons.CrossCircle/> : (
            iconType === "success" ? <Icons.CheckCircle/> : <Icons.InfoCircle/>
          )}
        
        >
          {message}
        </Alert>
        }

        {
          showBookMessage && <Alert id="bookMessage"
            dismissible={true}
            onDismissClick={() => {
              setShowBookMessage(false);
            }}
            sentiment={bookIconType === "error" ? Sentiments.Negative : (
              bookIconType === "success" ? Sentiments.Positive : Sentiments.Information
            )}
            icon={bookIconType === "error" ? <Icons.CrossCircle/> : (
              bookIconType === "success" ? <Icons.CheckCircle/> : <Icons.InfoCircle/>
            )}>
          {bookMessage}
        </Alert>
        }
        </div>
        <>
        <BookContainer>
              <Text size="small" id="bookId">Book</Text>
              <DropDownList
                content={bookService.getBooksFromAuction(
                  bidPanel.auction ? bidPanel.auction : ({} as IAuction)
                )}
                value={book}
                placeholder="Select Books"
                allowClear={false}
                disabled={
                  bidPanel.auction?.bidStatus === BidStatus.Closed ||
                  bidPanel.auction?.bidResult?.status === BidStatus.Closed ||
                  CheckForBidPanelFunctionalities(profilePage)
                }
                onSelect={onBookSelectionChanged}
                width="130px"
              ></DropDownList>
              {bookSelector.loading && <LoadingIndicator />}
              <Button 
              id="confirmButton"
              onClick={updateBookSelection} 
              disabled={
                CheckForBidPanelFunctionalities(profilePage) || (
                bidPanel.auction?.bidStatus === BidStatus.Closed ||
                bidPanel.auction?.bidResult?.status === BidStatus.Closed ||
                disableBookSubmission
                )
              } >
                Confirm
              </Button>
              {enableSpreadsheetUpload && (
                <StyledExcelDropzone
                  corridor={auction ? auction.corridor : ""}
                  interconnector={
                    auction && auction.interconnector
                      ? auction.interconnector
                      : ""
                  }
                  periodEndDate={
                    auction && auction.periodStop
                      ? auction.periodStop
                      : new Date()
                  }
                  currentBids={bidPanel.bids ? bidPanel.bids : []}
                  onSuccessfulValidation={onSuccessfulValidation}
                />
              )}
        </BookContainer>
        <PaginationStyle>
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            width: '100%', 
            justifyContent: 'space-between'
          }}>
            <Pagination
              className="pagination"
              total={totalPages}
              current={currentPage}
              defaultPageSize={1}
              onChange={updatePage}
              showTitle={false}
              itemRender={(page, type, element) =>
                renderPaginationItem(
                  page,
                  type,
                  element,
                  type === "page"
                    ? savedBids &&
                      savedBids[page - 1] &&
                      savedBids[page - 1].status
                      ? savedBids[page - 1].status.toString()
                      : ""
                    : ""
                )
              }
            />
            {savedBids &&
              savedBids.length > 1 &&
              !(
                bidPanel.auction?.bidStatus === BidStatus.Closed ||
                bidPanel.auction?.bidResult?.status === BidStatus.Closed
              ) && (
                <Button 
                  onClick={voidorDeleteAllBids}
                  disabled={CheckForBidPanelFunctionalities(profilePage)}
                >
                  {bidPanel.auction?.bidStatus === BidStatus.Accepted ||
                  bidPanel.auction?.bidStatus === BidStatus.Amended
                    ? "Void All Bids"
                    : "Delete All Bids"}
                </Button>
              )}
          </div>
        </PaginationStyle>
        <hr />
        {bidPanel?.auction?.bidStatus !== BidStatus.Closed &&
          !CheckForBidPanelFunctionalities(profilePage) && (
            <div>
              <Text size="small" id="applyLabel">
                Apply Same Quantity and Price for all items
              </Text>
              <QuantityAndPriceApplyLabelStyle>
                <div>
                <Text size="small" id="quantityLabel">Quantity</Text>
                </div>
                <div>
                <Text size="small" id="priceLabel">Price (€)</Text>
                </div>
              </QuantityAndPriceApplyLabelStyle>

              <QuantityAndPriceApplyEntryStyle>
                <TextInput
                    
                    type="number" 
                    placeholder="Enter Quantity"
                    value={bidQuantityTextBoxVal} 
                    onChange={(x: React.FormEvent<HTMLInputElement>) => {
                      const newQuantity = x.currentTarget.value;
                      //only allow whole numbers
                      const re = /^[0-9\b]+$/;
                      const shouldUpdateQuantity =
                        newQuantity === "" || re.test(newQuantity);
                      if (shouldUpdateQuantity) {
                        validateEntryForApplyQuantityAndPriceToAll(
                          newQuantity,
                          priceTextBoxVal
                        );
                      }
                    }}   
                    onWheel={onWheelHandle}               
                  />
                <TextInput
                  type="number"
                  placeholder="Enter Price"
                  value={priceTextBoxVal}
                  onChange={(x: React.FormEvent<HTMLInputElement>) => {
                    const price = x.currentTarget.value;
                    validateEntryForApplyQuantityAndPriceToAll(
                      bidQuantityTextBoxVal,
                      price
                    );
                  }}
                  onWheel={onWheelHandle}
                 />

                <Button
                  id="applyButton"
                  onClick={applyPriceAndQuantityAcrossAllFields}
                  disabled={disableApplyBtn}
                >
                  Apply to all
                </Button>
              </QuantityAndPriceApplyEntryStyle>
            </div>
          )}
        </>
        <BidAreaStyle hasAlerts={hasAlerts}>
          <div>
            <BidGridStyle
              alertCount={activeAlertCount} 
            maintenanceMessagesCount={maintenanceMessagesCount}>
              <BidGrid
                columns={dailyBidProductColumns()}
                rowData={savedBids}
                theme={theme}
                onGridEvent={onGridReady}
                onCellValueChanged={onCellValueChanged}
                onCellKeyDown={onCellKeyDown}
                gridOptions={gridOptions}
                auctionIdentification={bidPanel?.auction?.identification}
                panelId={currentPage} />
            </BidGridStyle>
          </div>
        </BidAreaStyle>
        <div
          style={{
            columnGap: "1rem",
            display: "flex",
            marginTop: "1rem",
            marginBottom: "1rem",
          }}
        >
          <Text size="small" id="quantityAndPriceLabel">
            Quantity {currentPage} & Price {currentPage}
          </Text>
          <Button
            disabled={
              bidPanel.auction?.bidStatus === BidStatus.Closed ||
              CheckForBidPanelFunctionalities(profilePage) ||
              disableAddQtyAndPriceButton
            }
            id="addQtyAndPriceButton"
            onClick={addBid}
          >
            + Qty & Price
          </Button>
          {savedBids[currentPage - 1] &&
            savedBids[currentPage - 1].status === BidStatus.Draft && (
              <Button
                id="deleteButton"
                icon={<Icons.Trash></Icons.Trash>}
                disabled={
                      bidPanel.auction?.bidStatus === BidStatus.Closed ||
                      CheckForBidPanelFunctionalities(profilePage) ||
                      currentPage === 1
                    }
                onClick={deleteBid}
              >
                Delete Bid
              </Button>
            )}
          {savedBids[currentPage - 1] &&
            savedBids[currentPage - 1].status !== BidStatus.Draft && (
              <Button
                id="voidButton"
                icon={<Icons.Trash></Icons.Trash>}
                disabled={bidPanel.auction?.bidStatus === BidStatus.Closed || CheckForBidPanelFunctionalities(profilePage)}
                onClick={voidBid}>
                Void Bid
              </Button>
            )}
          {/* <Modal title='Are you sure you want to void this bid?' onClose={onCloseDeleteModal} visible={showDeleteModal} /> */}
        </div>
      </BidBodyModal>
      <BidFooterModal>
        <Button
          icon={<Icons.ArrowCcw></Icons.ArrowCcw>}
          id="bidHistoryButton"
          onClick={() => {
            if (bidPanel.auction?.identification) {
              dispatch(
                FetchSubmissionHistory(bidPanel.auction?.identification)
              );
            }
          }}
        >
          History(Bidding open)
        </Button>
        <Button
          id="bidSubmitButton"
          disabled={disableSubmitButton}
          onClick={submitBid}
        >
          {submitBtnText}
        </Button>
        {bidPanel.loading && <LoadingIndicator />}
      </BidFooterModal>
      <BidHistory biddingOpen={bidPanel.auction?.biddingOpen} />
    </BidPanelStyle>
  );
};
export default Bids;

const StyledExcelDropzone = styled(ExcelDropzone)`
  margin-right: 5px;
  padding-right: 5px;
  pointer: cursor;
`;
